"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const ContentConversion_1 = require("./ContentConversion");
const auth_1 = require("../auth");
const ads_1 = require("../ads");
exports.CONVERSION_STEP_TYPES = [
    'screenshot',
    'remove',
    'unwrap',
    'hostImage',
    'renameAttribute',
    'updateAttributeContents',
    'findAndReplace',
    'convertHtmlEntities',
    'insertAd',
];
let ContentConversionStep = class ContentConversionStep extends OsmosysBaseEntity_1.OsmosysBaseEntity {
    constructor() {
        super(...arguments);
        this.paused = false;
        this.adjacentInsertionPosition = 'afterend';
    }
};
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStep.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStep.prototype, "name", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Number, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'integer',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStep.prototype, "order", void 0);
tslib_1.__decorate([
    type_graphql_1.Field({ nullable: true }),
    typeorm_1.Column({ nullable: true }),
    class_validator_1.IsIn(exports.CONVERSION_STEP_TYPES),
    tslib_1.__metadata("design:type", String)
], ContentConversionStep.prototype, "type", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => ContentConversion_1.ContentConversion, { nullable: true }),
    typeorm_1.ManyToOne(() => ContentConversion_1.ContentConversion, contentConversion => contentConversion.steps, { lazy: true }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStep.prototype, "contentConversion", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.RelationId((obj) => obj.contentConversion),
    tslib_1.__metadata("design:type", Number)
], ContentConversionStep.prototype, "contentConversionId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => ads_1.Ad, { nullable: true }),
    typeorm_1.ManyToOne(() => ads_1.Ad, ad => ad.conversionStepsUsedIn),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStep.prototype, "ad", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStep.prototype, "selector", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStep.prototype, "linkSelector", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'boolean',
    }),
    tslib_1.__metadata("design:type", Boolean)
], ContentConversionStep.prototype, "linkToContentItem", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'boolean',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStep.prototype, "linkToFirstLink", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({
        default: false,
        nullable: false,
        type: 'boolean',
    }),
    tslib_1.__metadata("design:type", Boolean)
], ContentConversionStep.prototype, "paused", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", String)
], ContentConversionStep.prototype, "cssForATag", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", String)
], ContentConversionStep.prototype, "cssForImgTag", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Number, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'integer',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStep.prototype, "imgWidth", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", String)
], ContentConversionStep.prototype, "toAttribute", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStep.prototype, "fromAttribute", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStep.prototype, "includedHtml", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStep.prototype, "headHtml", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStep.prototype, "overlayHtml", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStep.prototype, "attributes", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStep.prototype, "attributeName", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStep.prototype, "attributeValue", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStep.prototype, "attributeRemovalStrategy", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String),
    typeorm_1.Column({
        default: 'afterend',
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", String)
], ContentConversionStep.prototype, "adjacentInsertionPosition", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { nullable: true }),
    typeorm_1.Column({
        default: false,
        nullable: true,
        type: 'boolean',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStep.prototype, "doNothingIfAttributeExists", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", String)
], ContentConversionStep.prototype, "removeTarget", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStep.prototype, "textToFind", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStep.prototype, "textToReplace", void 0);
ContentConversionStep = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], ContentConversionStep);
exports.ContentConversionStep = ContentConversionStep;
class ContentConversionStepEntity extends ContentConversionStep {
    toEndpoint() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return '/integrations';
        });
    }
    toString() {
        return this.name || '';
    }
}
exports.ContentConversionStepEntity = ContentConversionStepEntity;
//# sourceMappingURL=ContentConversionStep.js.map